import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { IntegrationService } from '../../../../shared/services/integration.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'common-tooltip-with-icon-image',
    templateUrl: './common-tooltip-with-icon-image.component.html',
    styleUrls: ['./common-tooltip-with-icon-image.component.scss'],
    standalone: true,
    imports: [MatTooltip]
})
export class CommonTooltipWithIconImageComponent implements OnInit, MatTooltipModule {
  @Input('tooltip') infoMessage: string;
  @Input() matTooltip: string;
  public tooltipIcon: string;

  constructor(
    private integrationService: IntegrationService,
    private domSanitizer: DomSanitizer
  ) {}
  ngOnInit(): void {
    this.matTooltip = this.infoMessage;
    const assetUrl = this.integrationService.getApplicationPath() + 'assets/images/Information-outlined.svg';
    this.tooltipIcon = this.domSanitizer.sanitize(
      SecurityContext.RESOURCE_URL,
      this.domSanitizer.bypassSecurityTrustResourceUrl(assetUrl)
    );
  }
}
